export default {"src":"/_next/static/media/GR.cf4b3dfe.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};